define(function(require) {
    const tpl = require('./templates/t_itv_electronic_plans.hbs');

    const Radio = require('backbone.radio');

    return Marionette.ItemView.extend({
      template: tpl,
      regions: {
      },
      ui: {
        'iconPreview': '.file-icon-preview',
        'imagePreview': '.image-thumbnail',
        'noEplanAttachment': '.no-eplan-attachments.empty-message'
      },
      events: {
      },
      className: 'electronic-plan-attachment-item',
      initialize: function(options) {
        this.config = options.config;
      },
      onRender: function() {
        this.$el.rhythmCivicsTooltipInit();
        this.$el.rhythmThemeInitCivics();
        this.$el.rhythmThemeInit();
      },
      onShow: function() {
          this.ui.imagePreview.show();
          this.ui.iconPreview.show();

          if(this.config.temporaryAttachments && this.config.temporaryAttachments.length > 0)
          {
            this.ui.noEplanAttachment.hide();
          }
      },
      templateHelpers: function() {
        var self = this;
        var count = self.config.temporaryAttachments ? self.config.temporaryAttachments.length : 0;
        return {
          viewName: self.config.viewName,
          ePlanAttachmentList:  self.config.temporaryAttachments,
          totalCount: count,
        };
      }
    });
  });
